class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.initialProductAdded();

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  initialProductAdded() {
    // START CUSTOM CART GIFTS
    const customCartGifts = this.querySelector(".custom-cart__gifts");
    if (customCartGifts) {
      const progressBar = customCartGifts.querySelector('.custom-cart__gifts-drag');
      const cartKey = 'sprv-cart-prev-width';
      const newWidth = progressBar.dataset.progressWidth;
      const previousWidth = sessionStorage.getItem(cartKey) || '0';
      progressBar.style.width = `${previousWidth}%`;
      setTimeout(() => {
        progressBar.style.width = `${newWidth}%`;
      }, 50);
      sessionStorage.setItem(cartKey, newWidth);
      
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          const cartItems = document.querySelector('cart-drawer-items');
          const triggerAmount = +customCartGifts.dataset.triggerAmount;
          const cartTotal = cart.total_price / 100;
          const giftAdded = this.querySelector('.giftAdded');
          if (cartTotal >= triggerAmount) this.addSurprise(cart);
          if (cartTotal < triggerAmount && giftAdded) cartItems.updateQuantity(giftAdded.dataset.index, 0);
        });
    }
    // END CUSTOM CART GIFTS
    
    // START SWIPER UPSELLS
    const customCartUpsells = document.querySelectorAll('.custom-cart .swiper');
    customCartUpsells.forEach(upsellSlider => {
      const paginationContent = upsellSlider.querySelector('.swiper-pagination');
      const swiper = new Swiper(upsellSlider, {
        pagination: {
          el: paginationContent,
          clickable: true,
        },
        autoHeight: true,
        slidesPerView: +upsellSlider.dataset.slides,
        spaceBetween: 30
      });
    });
    // END SWIPER UPSELLS
  }

  addSurprise(cart) {
    const customCartGifts = this.querySelector(".custom-cart__gifts");
    const allCartItems = document.querySelectorAll('.cart-item');
    const variantId = customCartGifts.dataset.variantId;
    let productAlreadyInCart = false;
    
    allCartItems.forEach(cartItem => {
      if(cartItem.dataset.itemId === variantId) productAlreadyInCart = true; 
    });

    if (!productAlreadyInCart) {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = () => {
        if (xhr.status === 200) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'drawer',
            productVariantId: variantId,
          });
        }
      };
      var data = JSON.stringify({ quantity: 1, id: variantId });
      xhr.send(data);
    }
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
